import { api } from '@/lib/api';

export const staffService = {
  async getAll() {
    const { data } = await api.get('/staff');
    return { data };
  },

  async create(body) {
    const { data } = await api.post('/staff', body);
    return { data };
  },

  async update(id, body) {
    const { data } = await api.patch(`/staff/${id}`, body);
    return { data };
  },

  async delete(id) {
    await api.delete(`/staff/${id}`);
    return { success: true };
  },
};
